import React, { useEffect, useState } from 'react';
import { WifiOff } from 'lucide-react';
import { toast } from 'sonner';

// Shows an offline banner and a "back online" sync toast. The installable-PWA
// prompt now lives as a small icon in the sidebar profile box (see Layout.js +
// hooks/useInstallPrompt).
export const PWAStatus = () => {
  const [offline, setOffline] = useState(!navigator.onLine);

  useEffect(() => {
    const goOffline = () => setOffline(true);
    const goOnline = () => {
      setOffline(false);
      toast.success('Back online — syncing latest data');
    };
    window.addEventListener('offline', goOffline);
    window.addEventListener('online', goOnline);
    return () => {
      window.removeEventListener('offline', goOffline);
      window.removeEventListener('online', goOnline);
    };
  }, []);

  if (!offline) return null;
  return (
    <div
      data-testid="offline-banner"
      className="fixed top-0 inset-x-0 z-[60] flex items-center justify-center gap-2 bg-amber-500 text-black text-xs font-semibold py-1.5 px-3"
    >
      <WifiOff className="w-3.5 h-3.5" />
      You're offline — showing cached dashboards & reports
    </div>
  );
};

export default PWAStatus;
